import { render } from "./WirepasDataCleanupGrid.vue?vue&type=template&id=6a13407a&scoped=true&ts=true"
import script from "./WirepasDataCleanupGrid.vue?vue&type=script&lang=ts"
export * from "./WirepasDataCleanupGrid.vue?vue&type=script&lang=ts"

import "./WirepasDataCleanupGrid.vue?vue&type=style&index=0&id=6a13407a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a13407a"]])

export default __exports__